import React, { useEffect, useState } from "react";

const CountDown = ({
  regBefore,
  submissionClose,
  hasRegistered,
}) => {

  const [regTime, setRegTime] = useState(0);
  const [subTime, setSubTime] = useState(0);

  useEffect(() => {
    const updateTimes = () => {
      const now = new Date();
      const newRegTimeDiff = Math.floor(
        (new Date(regBefore).getTime() - now.getTime()) / 1000
      );
      const newSubTimeDiff = Math.floor(
        (new Date(submissionClose).getTime() - now.getTime()) / 1000
      );

      setRegTime(Math.max(newRegTimeDiff, 0));
      setSubTime(Math.max(newSubTimeDiff, 0));
    };

    updateTimes();
    const intervalId = setInterval(updateTimes, 1000);

    return () => clearInterval(intervalId);
  }, [regBefore, submissionClose]);

  const formatTime = (time) => {
    const days = Math.floor(time / 86400);
    const hours = Math.floor((time % 86400) / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;

    const pad = (n) => (n < 10 ? `0${n}` : n.toString());

    return `${pad(days)}d : ${pad(hours)}h : ${pad(minutes)}m : ${pad(
      seconds
    )}s`;
  };

  if (!(regBefore instanceof Date) || !(submissionClose instanceof Date)) {
    console.error("Invalid Date objects passed");
    return null;
  }

  return (
    <div>
      {!hasRegistered && regTime > 0 && (
        <div className="w-full text-center">
          <p className="text-black text-xl font-gilroy-semibold mb-1">
            Registration Ends in
          </p>
          <p className="text-[#008080] text-xl font-gilroy-bold">{formatTime(regTime)}</p>
        </div>
      )}

      {hasRegistered && subTime > 0 && (
        <div className="w-full text-center">
          <p className="text-black text-xl font-gilroy-semibold mb-1">
            Submission Ends in
          </p>
          <p className="text-[#008080] text-xl font-gilroy-bold">{formatTime(subTime)}</p>
        </div>
      )}
    </div>
  );
};

export default CountDown;
